/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
// import Pagination from "react-js-pagination";
import Loader from "../Loader";
import { useNavigate, Link } from 'react-router-dom';
axios.defaults.timeout = 300000; 

const Step1 = ({ onNext,cid, role,token, formData, setFormData }) => {
    const [methodType, setMethodType] = useState(0); // 0 for 'Paste Numbers', 1 for 'File Upload'
    const [action, setAction] = useState(); // 0 for 'Change Route Option', 1 for 'Disconnect'
    const [loading, setLoading] = useState(true); 
    const [telephoneNumbers, setTelephoneNumbers] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [stateList, setStateList] = useState([]);
    const [selectedRoutingOption, setSelectedRoutingOption] = useState('');
    const [companyList, setcompanyList] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [e911Comapny, setE911Comapny] = useState(false);
    const [cnameComapny, setCnameComapny] = useState(false);
    const [file, setFile] = useState(null);
    const [errorList, setErrorList] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [showCustomerValidationError, setShowCustomerValidationError] = useState(false);
    const [setinstrunction, setInstrunction] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const errorListRef = useRef(null);
    const [error, setError] = useState('');
    const [inventoryAccess, setInventoryAccess] = useState(false);
    const [userInventoryAccess, setUserInventoryAccess] = useState(true);
    const [userCnameValue, setUserCnameValue] = useState(false);
    const [userE911Value, setUserE911Value] = useState(false);
    const [e911Address, setE911Address] = useState({       
        housenumber: '',
        housesuffix:'',
        predirectional:"",
        streetname: '',
        streetsuffix:"",
        postdirectional:"",
        addressline2:"",
        plusfour:"",        
        city: '',
        state: '',
        zip: '',
        county:"",
        country:"",
        latitude:"",
        longitude:""
    });
    const [validationErrors, setValidationErrors] = useState({
        housenumber: false,
        housesuffix:false,
        predirectional:false,
        streetname: false,
        streetsuffix:false,
        postdirectional:false,
        addressline2:false,
        plusfour:false,
        city: false,
        state: false,
        zip: false,
        county:false,
        country:false,
        latitude:false,
        longitude:false
      });
    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
    };
    useEffect(() => {
        if(token){
         getCustomerNameList();
         getStateList();
        }
         
     }, [token]);

   
    useEffect(() => {
        
        const compId =  role <= 2 ? selectedValue : cid ;
        console.log(compId);
        setFormData({ ...formData, selectedCompany: compId });
    }, [selectedValue, cid]);

    useEffect(() => {
        // Scroll to the errorListRef if Object.entries(errorList).length > 0
        if (Object.entries(errorList).length > 0) {
            console.log("scroll");
          errorListRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, [errorList]);
      useEffect(() => {
        // console.log(formData);
        if(formData.selectedCompany){
            getCustomerE911Access();
            getUserAccess();
        }
        
    },[formData.selectedCompany]);

    // useEffect(() => {
    //     console.log(e911Comapny);
    // },[e911Comapny]);

    const getCustomerNameList = async () => {
        try {
          
            const response = await axios.get(`${baseUrl}/active-user-company`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            // const allArray = response.data.slice(1);
            const allArray = response.data.filter(item => item.id !== 1);
            setcompanyList(allArray);
            // console.log(allArray);
            //     setLoading(false); 
            // if(allArray.statusCode == 200){
            //     console.log(allArray.data);
            //     setRoutingList(allArray.data)
            // }
           
            
            
          
        } catch (error) {
            setLoading(false);
           console.log(error);
            
        }
    };

    const getStateList = async () => {
        try {
          
            const response = await axios.get(`${baseUrl}/state`);
            const allArray = response.data;
            
            setStateList(allArray.list);
            
        } catch (error) {
            
           console.log(error);
          
        }  
    };

    const getCustomerE911Access = async () => {
        try {
            setPopupOpen(true);
            // setApiCallCount((prevCount) => prevCount + 1);
            const response = await axios.get(`${baseUrl}/check-company-e911-access/${formData.selectedCompany}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            setPopupOpen(false);
            setE911Comapny(response.data.e911_switch === 1 ? true : false);
            setCnameComapny(response.data.cname_switch === 1 ? true : false);
            setInventoryAccess(response.data.inventory_switch === 1 ? true : false);
            // const allArray = response.data.slice(1);
            // console.log(allArray);
            // setApiResponseCount((prevCount) => prevCount + 1);
            // setcompanyList(allArray);
           
           
            
            
          
        } catch (error) {
            // setLoading(false);
            setPopupOpen(false);
           console.log(error);
            
        }
    };

    const getUserAccess = async () => {
        try {
            const response = await axios.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setUserCnameValue(response.data.user_cname_switch == 0 ? false : true);
            setUserE911Value(response.data.user_e911_switch == 0 ? false : true);
            setUserInventoryAccess(response.data.user_inventory_switch == 0 ? false : true);
            
            
        } catch (error) {
           console.log(error);
        }
    }
    const handleCompanyChange = (e) => {
        setSelectedValue(e.target.value);
        console.log(formData);
        const compId =  role <= 2 ? cid : e.target.value;
        setFormData({ ...formData, selectedCompany: e.target.value });
    };
    const handleRadioChange = (e) => {
        setMethodType(Number(e.target.value));
        setErrorList([]);
    };
    const handleAction = (e) => {
        setAction(Number(e.target.value));
    };


    const toggleInstruction = () => {
        setInstrunction(!setinstrunction);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setE911Address((prevData) => ({
          ...prevData,
          [name]: value
        }));
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };
  
    const handleClearClick = (e) => {
        e.preventDefault();
        setTelephoneNumbers(''); // Clear the textarea value
        setIsValid(true);
        setErrorList([]);
    };

    const handleCnameChange = (e) => {
        
        const inputValue = e.target.value;
    
        // Regular expression to check if the input is valid
        // const isValidInput = /^[A-Za-z0-9 ]{0,15}$/.test(inputValue);
        const isValidInput = /^(?=(?:.*[A-Za-z]){1,})(?=(?:.*[A-Za-z0-9]){2,})[A-Za-z0-9 .,&_'-]{1,15}$/.test(inputValue);
        setInputValue(inputValue);
        if (isValidInput || inputValue.trim() === "") {
          
          setFormData({ ...formData, updateCname: inputValue });
          setError('');
        } else {
          setError("Invalid input. Only alphabetical & numbers characters and spaces .,&_-' allowed, up to 15 characters.");
        }
    };

    const handleNextClick = async(e) => {
        e.preventDefault();
        let hasCustomerValidationError = false;
        if( role <= 2 && selectedValue === ''){
            setShowCustomerValidationError(true);
            hasCustomerValidationError = true;
        }

        // Check if the input contains only numbers and commas
        const isValidInput = /^[0-9,]+$/.test(telephoneNumbers) &&
        telephoneNumbers.split(',').every(number => number.length === 10);
        // console.log(inputValue);
        // console.log(action);
        // console.log(methodType);
        console.log(inputValue, "inputValue");
        if(action === 0){
            
            // if (!inputValue){
            //     alert("Please enter cname");
            //     return;
            // }
            if(error){
                return;
            }
                
            const isValidInput = /^[0-9,]+$/.test(telephoneNumbers) && telephoneNumbers.split(',').every(number => number.length === 10);
            if(!isValidInput && methodType === 0){
                alert('Input is not valid. Please enter numbers separated by commas.');

            }else if(methodType === 0 && isValidInput && hasCustomerValidationError == false){
                const numbersArray = telephoneNumbers.split(',').map(number => number.trim());
                const tollFreePrefixes = ['800', '888', '877', '866', '855', '844', '833'];
                const tollFreeNumbers = numbersArray.filter(n => tollFreePrefixes.some(p => n.startsWith(p)));
                if (tollFreeNumbers.length > 0) {
                    alert(`CNAM is not allowed on Toll Free numbers: ${tollFreeNumbers.join(', ')}`);
                    return;
                }
                setFormData({ ...formData, action: action, methodType: methodType, updateCname:inputValue,e911Address:e911Address, tnNumberList: numbersArray });

                const response = await axios.post(`${baseUrl}/validate-feature-tnnumber`, {cname:inputValue,tnNumberList:numbersArray,action: action, methodType:methodType,company_id:formData.selectedCompany, file:null},{
                    headers: {
                         Authorization: `Bearer ${token}`,

                    }
                });
                const allArray = response.data;
                console.log(allArray.data);
                if(allArray.data){
                    setFormData({ ...formData, action: action, methodType: methodType, updateCname:inputValue, e911Address:e911Address, tnNumberList: allArray.data });
                    onNext();
                }else{
                    setErrorList(allArray);
                }
                // console.log(response);
                    
            }else if(methodType === 1  && hasCustomerValidationError == false){
                const data = new FormData();
                data.append("file", file);
                    const newData = new FormData();
                    newData.append("file", file);                
                    newData.append('company_id', formData.selectedCompany);
                    newData.append('methodType', methodType);
                    newData.append('cname', inputValue);
                    const response = await axios.post(`${baseUrl}/validate-feature-tnnumber`, newData,{
                        headers: {
                             Authorization: `Bearer ${token}`,
                             "Content-Type": "multipart/form-data",
                        }
                });
                const allArray = response.data;
                // console.log(allArray)
                if(allArray.data){
                    setFormData({ ...formData, action: action, methodType: methodType,updateCname:inputValue,e911Address:e911Address,  tnNumberList: allArray.data,  data:data });
                    onNext();
                }else{
                    setErrorList(allArray);
                }
            }
            
            
        }

        if(action === 1){
            const newValidationErrors = {
                housenumber: e911Address.housenumber  === '',
                housesuffix:e911Address.housesuffix  === '',
                predirectional:e911Address.predirectional  === '',
                streetname: e911Address.streetname === '',
                streetsuffix:e911Address.streetsuffix === '',
                postdirectional:e911Address.postdirectional === '',
                addressline2:e911Address.addressline2 === '',
                plusfour:e911Address.plusfour === '',
                city: e911Address.city === '',
                state: e911Address.state === '',
                zip:!/^\d{5}$/.test(e911Address.zip),
                county:e911Address.county === '',
                country:e911Address.country === '',
                latitude:e911Address.latitude === '',
                longitude:e911Address.longitude === '',
              };              
              setValidationErrors(newValidationErrors);
          
              // Check if there are any validation errors
              const hasErrors = Object.values(newValidationErrors).some((error) => error);
              
              if (!hasErrors) {
                
                const isValidInput = /^[0-9,]+$/.test(telephoneNumbers) && telephoneNumbers.split(',').every(number => number.length === 10);
                if(!isValidInput && methodType === 0){
                    alert('Input is not valid. Please enter numbers separated by commas.');
    
                }else if(methodType === 0 && isValidInput && hasCustomerValidationError == false){
                    const numbersArray = telephoneNumbers.split(',').map(number => number.trim());
                    setFormData({ ...formData, action: action, methodType: methodType, updateCname:inputValue, e911Address:e911Address, tnNumberList: numbersArray });
    
                    const response = await axios.post(`${baseUrl}/validate-feature-tnnumber`, {tnNumberList:numbersArray,action: action, methodType:methodType,company_id:formData.selectedCompany, file:null},{
                        headers: {
                             Authorization: `Bearer ${token}`,
    
                        }
                    });
                    const allArray = response.data;
                    console.log(allArray.data);
                    if(allArray.data){
                        setFormData({ ...formData, action: action, methodType: methodType, updateCname:inputValue,  e911Address:e911Address,tnNumberList: allArray.data });
                        onNext();
                    }else{
                        setErrorList(allArray);
                    }
                    // console.log(response);
                        
                }else if(methodType === 1  && hasCustomerValidationError == false){
                    const data = new FormData();
                    data.append("file", file);
                        const newData = new FormData();
                        newData.append("file", file);                
                        newData.append('company_id', formData.selectedCompany);
                        newData.append('methodType', methodType);
                        const response = await axios.post(`${baseUrl}/validate-feature-tnnumber`, newData,{
                            headers: {
                                 Authorization: `Bearer ${token}`,
                                 "Content-Type": "multipart/form-data",
                            }
                    });
                    const allArray = response.data;
                    // console.log(allArray)
                    if(allArray.data){
                        setFormData({ ...formData, action: action, methodType: methodType,updateCname:inputValue,e911Address:e911Address,  tnNumberList: allArray.data,  data:data });
                        onNext();
                    }else{
                        setErrorList(allArray);
                    }
                }
               
              } 
        }
          
    };


    return(
        <>
            <div className="row">
                <div className="col-6">
                    <div className="left-title">
                        <h1>Add, Update, Remove Features
                        {/* <span><img src={`${process.env.PUBLIC_URL}/images/view.png`} onClick={toggleInstruction} style={{ cursor: 'pointer' }} /></span> */}
                        </h1>
                    </div>
                </div>
                <div className="col-6">
                </div>
            </div>
            {popupOpen && (
                     <Loader /> 
                ) }
            {/* {setinstrunction && <div className="common-white-shadow-background setting-section">
            <div className="row">                
                <div className="introducebpx">
                    <p><strong>Instructions</strong></p>
                    <p>You can modify numbers by either uploading a list by pasting/entering numbers in the "Tel Numbers" field, or upload a CSV using the "File Upload" option. <br/>
                     Once you've either entered the telephone numbers or entered them, select the "Next" button.</p>
                </div>
            </div>
        </div>} */}
            {role <= 2 && <div className="common-white-shadow-background setting-section">
            <div className="row">
                <h3 className='comapny-label'>Select Company</h3>
                <div className="inputbox">
                    <select name="" id=""  value={selectedValue} onChange={(e) => handleCompanyChange(e)}>
                        <option value="">Select Company</option>
                        {companyList.map((comp) => (                                                                    
                                <option key={comp.id} value={comp.id}>
                                    {comp.cname}
                                </option>  
                            ))}
                     
                    </select>
                </div>
            </div>
            {showCustomerValidationError && (
        <p className="error">Please select a value from the dropdown.</p>
      )}
      </div>}
            {((cnameComapny && userCnameValue) || (e911Comapny && userE911Value)) && <div className="common-white-shadow-background setting-section">
                <div className="row">
                {inventoryAccess && userInventoryAccess && <div className="modification-txt">
                        <p>Use <span ><Link to={"/inventory"} className="green-text">Inventory</Link></span> page to download current number information.</p>
                    </div>}
                    <h3>Modification Entry Method</h3>
                    <div className="settingbox radio-standard-box">
                        <label for="pastNumber"><input type="radio" id="pastNumber" name="method_type" value={0} checked={methodType === 0} onChange={handleRadioChange} />
                            Paste Numbers</label>          
                        <label for="fileUpload"><input type="radio" id="fileUpload" name="method_type" value={1} checked={methodType === 1} onChange={handleRadioChange} />
                            File Upload</label>
                        
                    </div>
                    
                </div>
            </div>}
            {formData.selectedCompany && ((cnameComapny === true && userCnameValue == true) || (e911Comapny === true && userE911Value == true)) && <div className="common-white-shadow-background setting-section">
                <div className="row">
                    
                    <h3>Modification Type</h3>
                    <div className="settingbox radio-standard-box">
                        {formData.selectedCompany && cnameComapny && userCnameValue && <label for="changeRoute"><input type="radio" name="Search" id="changeRoute" value={0} checked={action === 0} onChange={handleAction} />
                        Add or Update Features(CNAM)</label>}
                        {/* <label for="disconnect"><input id="disconnect" type="radio" name="Search"  value={1} checked={action === 1} onChange={handleAction} />
                        Remove Features(CNAM)</label> */}
                        {formData.selectedCompany && e911Comapny && userE911Value && <label for="disconnect"><input id="disconnect" type="radio" name="Search"  value={1} checked={action === 1} onChange={handleAction} />
                       E911</label>}
                       
                    </div> 
                    {action === 0 && 
                    <div className="row new-route-option"  style={{ marginTop: '30px' }}>
                        {/* <h3>New Routing Option <span className="redtxt">*</span></h3>
                        <div className="modification-txt">
                            <p>Use <span className="green-text">Routing Options</span> page to view routing details.</p>
                        </div> */}
                        <div className="inputbox">
                        <div className='col-sm-6' >
                      <input
                        type="text"                         
                        value={inputValue}                       
                        onChange={handleCnameChange}                   
                        placeholder="Enter CNAM"
                        // style={{ textTransform: 'uppercase' }}
                      />
                      {error && <p style={{ color: 'red' }}>{error}</p>}
                    </div>
                    
                        </div>
                    </div>}  
                    {action === 1 && 
                    <div className="row col-md-24"  style={{ marginTop: '30px' }}>
                        <div className="row order-contect">
                            <div className="labelwithbox" >
                                <label>HouseNumber</label>
                                <div className="inputbox">
                                    <input type="text" name="housenumber" defaultValue={e911Address.housenumber}  onChange={handleInputChange} required />
                                    {validationErrors.housenumber && <div className="error error-message">Please Enter House Number.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>HouseSuffix</label>
                                <div className="inputbox">
                                    <input type="text" name="housesuffix" defaultValue={e911Address.housesuffix}  onChange={handleInputChange} required />
                                    {validationErrors.housesuffix && <div className="error error-message">Please Enter HouseSuffix.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>PreDirectional</label>
                                <div className="inputbox">
                                    <input type="text" name="predirectional" defaultValue={e911Address.predirectional}  onChange={handleInputChange} required />
                                    {validationErrors.predirectional && <div className="error error-message">Please Enter PreDirectional.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>StreetName</label>
                                <div className="inputbox">
                                    <input type="text" name="streetname" defaultValue={e911Address.streetname}  onChange={handleInputChange} required />
                                    {validationErrors.streetname && <div className="error error-message">Please Enter Street Name.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>StreetSuffix</label>
                                <div className="inputbox">
                                    <input type="text" name="streetsuffix" defaultValue={e911Address.streetsuffix}  onChange={handleInputChange} required />
                                    {validationErrors.streetsuffix && <div className="error error-message">Please Enter StreetSuffix.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>PostDirectional</label>
                                <div className="inputbox">
                                    <input type="text" name="postdirectional" defaultValue={e911Address.postdirectional}  onChange={handleInputChange} required />
                                    {validationErrors.postdirectional && <div className="error error-message">Please Enter PostDirectional.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>AddressLine2</label>
                                <div className="inputbox">
                                    <input type="text" name="addressline2" defaultValue={e911Address.addressline2}  onChange={handleInputChange} required />
                                    {validationErrors.addressline2 && <div className="error error-message">Please Enter Street AddressLine2.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>City</label>
                                <div className="inputbox">
                                    <input type="text" name="city" defaultValue={e911Address.city}  onChange={handleInputChange} required />
                                    {validationErrors.city && <div className="error error-message">Please Enter City.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>StateCode</label>
                                <div className="inputbox">
                                <select
                                          name="state"
                                          value={e911Address.state}
                                          onChange={handleInputChange} required
                                        >
                                         <option value="">##</option>
                                        {stateList.map((state) => (                                                                    
                                            <option key={state.id} data-id={state.id} value={state.code}>
                                                {state.code}
                                            </option>  
                                        ))}
                                        </select>
                                    {/* <input type="text" name="state" defaultValue={e911Address.state}  onChange={handleInputChange} required /> */}
                                    {validationErrors.state && <div className="error error-message">Please Enter valid State Code.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>Zip</label>
                                <div className="inputbox">
                                    <input type="number"  name="zip" defaultValue={e911Address.zip}  onChange={handleInputChange} required />
                                    {validationErrors.zip && <div className="error error-message">Please Enter valid Zip.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>PlusFour</label>
                                <div className="inputbox">
                                    <input type="text"  name="plusfour" defaultValue={e911Address.plusfour}  onChange={handleInputChange} required />
                                    {validationErrors.plusfour && <div className="error error-message">Please Enter valid PlusFour.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>County</label>
                                <div className="inputbox">
                                    <input type="text"  name="county" defaultValue={e911Address.county}  onChange={handleInputChange} required />
                                    {validationErrors.county && <div className="error error-message">Please Enter valid County.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>Country</label>
                                <div className="inputbox">
                                    <input type="text"  name="country" defaultValue={e911Address.country}  onChange={handleInputChange} required />
                                    {validationErrors.country && <div className="error error-message">Please Enter valid Country.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>Latitude</label>
                                <div className="inputbox">
                                    <input type="text"  name="latitude" defaultValue={e911Address.latitude}  onChange={handleInputChange} required />
                                    {validationErrors.latitude && <div className="error error-message">Please Enter valid Latitude.</div>}
                                </div>
                            </div>
                            <div className="labelwithbox" >
                                <label>Longitude</label>
                                <div className="inputbox">
                                    <input type="text"  name="longitude" defaultValue={e911Address.longitude}  onChange={handleInputChange} required />
                                    {validationErrors.longitude && <div className="error error-message">Please Enter valid Longitude.</div>}
                                </div>
                            </div>
                        </div>
                    </div>}               
                </div>
            </div>}
            
            {((cnameComapny && userCnameValue) || (e911Comapny && userE911Value)) && 
            <>
            {methodType === 0 ? (
            <div className="common-white-shadow-background setting-section">
                <div className="row">
                    
                    <h3>Tel Numbers*</h3>
                    
                   
                    <div className="tel-number-textarea">
                         <p>Paste or manually enter Tel Numbers, separated by comma.</p>
                         <input type="textarea" value={telephoneNumbers} onChange={(e) => setTelephoneNumbers(e.target.value)} />
                        <a className="unassigned" href="#" onClick={handleClearClick}>Clear</a>
                    </div>
                    
                </div>
            </div>
             ) : (
            <div className="common-white-shadow-background setting-section">
                <div className="row">
                    
                    <h3>Upload File (Using Template)</h3>
                    <div className="download-templte">
                        <a className="newrow" target="_blank" href={`${process.env.PUBLIC_URL}/template/UpdateFeatures_Template.xlsx`}>Download Template</a>
                        <p>Submissions must be in the format of this template</p>
                    </div>
                    <div className="file-upload-field">
                        <div className="upload-btn-wrapper">
                              <input type="file" name="myfile" onChange={handleFileChange} placeholder="Select your local file based on our template" />
                            </div>
                    </div>
                    
                </div>
            </div>
             )}
             </>
            }
             {formData.selectedCompany && ((!cnameComapny || !userCnameValue) && (!e911Comapny || !userE911Value)) &&
                <div className="common-white-shadow-background setting-section">
                    <div className="row error">
                    You don't have access to the features.
                    </div>
                </div>
             }
            <div className="row footer-row">
            <Link className="Cancel" to={"/number-management"}>Cancel</Link>
                <a href="#" className="next" onClick={handleNextClick}>Next</a>
            </div>
            
            <div style={{'color':"red","paddingBottom":"30px"}} ref={errorListRef}>{ Object.entries(errorList).length > 0 && <p>Please resolve below errors</p>}<table  className="tablebox search-result-table order-result-table">
                                        
                                        <tbody>
                                            {Object.entries(errorList).map(([key, value]) => (
                                                 key !== 'statusCode' && key !== 'show' && (
                                              <tr key={key}>
                                                <td><strong>{key}:</strong></td>
                                                <td >{key === 'status' ? (
            value
              .split(',')
              .map((item, index) => (
                <p key={index}>{item.trim()}</p>
              ))
          )  :
            key === 'result' && Array.isArray(value) ? (
              value.map((item, index) => (
                <p key={index}>{item}</p>
              ))
            ) : (
              value
            )}</td>
                                              </tr>
                                            )))}
                                        </tbody>
                                    </table></div>
        </>
    );
}

const Step2 = ({ onBack, onNext, token, formData, setFormData  }) => {

    const [contacts, setContacts] = useState([
        { name: '', phone: '', extension: '', alias: '' }
    ]);
    const [validationErrors, setValidationErrors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [companyEmail, setCompanyEmail] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [userRole, setUserRole] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (token) {
            const decoded = jwt_decode(token);
            setUserEmail(decoded.email || '');
            setUserRole(decoded.role || '');
        }
    }, [token]);

    useEffect(() => {
        if (formData.selectedCompany) {
            axios.get(`${baseUrl}/get-company-email/${formData.selectedCompany}`)
                .then(res => {
                    setCompanyEmail(res.data[0]?.email || '');
                    setCompanyName(res.data[0]?.name || '');
                })
                .catch(err => console.log(err));
        }
    }, [formData.selectedCompany]);

    useEffect(() => {
        if (validationErrors.length > 0) {
            const errorMessages = validationErrors.join('\n');
            alert(errorMessages);
        }
    }, [validationErrors]);

    const handleContactChange = (e, index) => {
        const { name, value } = e.target;
        const updatedContacts = [...contacts];
        const fieldName = name.split('-')[0];
        updatedContacts[index][fieldName] = value;
    
        setContacts(updatedContacts);
    };

    const contactInputs = contacts.map((contact, index) => (
        <div className="row order-contect" key={index}>
        <div className="labelwithbox" >
            <label>Name</label>
            <div className="inputbox">
                <input
                    type="text"
                    name={`name-${index}`}
                    value={contact.name}
                    onChange={(e) => handleContactChange(e, index)}
                    required
                />
            </div> </div>
            {/* <div className="labelwithbox">
                    <label>Work Phone</label>
                    <div className="inputbox">
                         <input type="text" name={`phone-${index}`} value={contact.phone}
                    onChange={(e) => handleContactChange(e, index)}
                    required />
                    </div>
                </div>
                <div className="labelwithbox">
                    <label>Extension</label>
                    <div className="inputbox">
                        <input type="text" name={`extension-${index}`} value={contact.extension}
                    onChange={(e) => handleContactChange(e, index)}
                     />
                    </div>
                </div> */}
                 <div className="labelwithbox">
                    <label>Email</label>
                    <div className="inputbox">
                        <input type="email" name={`alias-${index}`} value={contact.alias}
                    onChange={(e) => handleContactChange(e, index)} required />
                    </div>
                </div>
                {/* <div className="labelwithbox">
                    <label></label>
                    <div className="inputbox">
                       
                        {index === 0 ? (
                            <a className="newrow" onClick={handleAddContact} href="#">+ Add Contact</a>
                        ) : (
                            <a className="newrow" onClick={() => handleRemoveContact(index)} href="#">Delete</a>
                        )}
                    </div>
                </div> */}
        </div>
       
    ));

    const handleNext = async(e) => {
        e.preventDefault();
        const errors = contacts.map((contact, index) => {
            const contactErrors = [];

            // if (!contact.name) {
            //     contactErrors.push(`Row ${index + 1}: Name is required`);
            // }
            // if (!/^\d{3}-\d{3}-\d{4}$/.test(contact.phone)) {
            //     contactErrors.push(`Row ${index + 1}: Phone is invalid and format is 111-111-1111`);
            // }
            // if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.alias)) {
            //     contactErrors.push(`Row ${index + 1}: Email is invalid`);
            // }

            return contactErrors;
        });
        setValidationErrors(errors.flat());

        if (errors.some(rowErrors => rowErrors.length > 0)) {
            return;
        } else if (userRole > 2 && !isCheckboxChecked) {
            alert('Please accept the disclaimer to proceed.');
            return;
        } else {
            
            if(formData.action === 0){
                setButtonDisabled(true);
                setPopupOpen(true);
                const newData = new FormData();
                if(formData.methodType === 1){
                    newData.append("file", formData.data.get("file"));
                }else{
                    newData.append("tnNumberList", JSON.stringify(formData.tnNumberList));
                }
                newData.append("contacts", JSON.stringify(contacts));
                newData.append('company_id', formData.selectedCompany);
                newData.append('action', formData.action);
                newData.append('methodType', formData.methodType);
                newData.append('cname', formData.updateCname);

                console.log(newData);
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                  
                if (formData.methodType === 1) {
                    headers["Content-Type"] = "multipart/form-data";
                }
                const response = await axios.post(`${baseUrl}/modify-cname-feature-tnnumber`, newData,{
                    headers: headers
                });
                        const allArray = response.data;
                        console.log(allArray); 
                        navigate("/order-new-number-success", { state: allArray }); 
            }

            if(formData.action === 1){
                setButtonDisabled(true);
                setPopupOpen(true);
                const newData = new FormData();
                if(formData.methodType === 1){
                    newData.append("file", formData.data.get("file"));
                }else{
                    newData.append("tnNumberList", JSON.stringify(formData.tnNumberList));
                }
                newData.append("contacts", JSON.stringify(contacts));
                newData.append('company_id', formData.selectedCompany);
                newData.append('action', formData.action);
                newData.append('methodType', formData.methodType);
                newData.append('e911Address', JSON.stringify(formData.e911Address));

                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                  
                if (formData.methodType === 1) {
                    headers["Content-Type"] = "multipart/form-data";
                }
                const response = await axios.post(`${baseUrl}/modify-e911-feature-tnnumber`, newData,{
                    headers: headers
                });

                console.log(response);
                const allArray = response.data;
                console.log(allArray); 
                navigate("/order-new-number-success", { state: allArray }); 
            }
            
            
        }
    }

    return(
        <>
        {popupOpen && (
                     <Loader /> 
                ) }
            <div className="row">
                <div className="col-6">
                    <div className="left-title">
                        <h1>Add, Update, Remove Features</h1>
                    </div>
                </div>
                <div className="col-6">
                </div>
            </div>
            <div className="common-white-shadow-background setting-section tableinput-section order-number-four-table">
                <div className="row">
                    <div className="order-con-title">Secondary Order Contact</div>

                </div>
                {contactInputs}
            </div>
            <div className="common-white-shadow-background setting-section tableinput-section order-number-four-table">
                <strong>Note:- </strong>Additional to secondary contact we will send order details to below email addresses.<br/>
                <ul>
                    {userEmail && <li>{userEmail}</li>}
                    <li>provisioning@broadbanddynamics.com</li>
                    {companyEmail && <li>{companyEmail}</li>}
                </ul>
            </div>
            {userRole > 2 && <div className="common-white-shadow-background setting-section tableinput-section order-number-four-table">
                <label htmlFor="featureDisclaimerCheckbox">
                    <input
                        type="checkbox"
                        id="featureDisclaimerCheckbox"
                        checked={isCheckboxChecked}
                        onChange={(e) => setIsCheckboxChecked(e.target.checked)}
                    /> &nbsp; By submitting this order, I confirm that {companyName} meets all regulatory requirements, including adhering to local, state, and federal laws, to order and utilize these numbers and/or features.
                </label>
                <br />
            </div>}
            <div className="row footer-row">
                    <div className="footer-row-left">
                        <a href="#" onClick={onBack} className="Back"> <img src="images/back-arrow.png" />Back</a>
                    </div>
                    <div className="footer-row-right">
                        {/* <a href="#" className="Cancel">Cancel</a> */}
                        <Link className="Cancel" to={"/number-management"}>Cancel</Link>
                        <a href="#"  className={buttonDisabled ? 'next disabled-link' : 'next'} onClick={handleNext} >Complete Order</a>
                    </div>
                </div>
        </>
    );
}
 
const FeaturesNumber = () => {
    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [numberManagementAccess, setNumberManagementAccess] = useState(true);
    const [cid, setCid] = useState('');
    const [formData, setFormData] = useState([]);
    const [step, setStep] = useState(1);
   
    

    
    
    const navigate = useNavigate();
 
    useEffect(() => {
        refreshToken();
        getUserAccess();
    }, []);

    useEffect(() => {
        if(access.length > 0 && token){
            checkAccess(access, token);
        }
    }, [access, token, numberManagementAccess]);
    
 
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded.exp);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setAccess(response.data.results);
            setNumberManagementAccess(response.data.number_management_switch == 0 ? false : true);
            // setIsLoading(false);
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    
    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
    };

    const checkAccess = async (access) => {
        if(!hasPermission('ordernewnumber') || !numberManagementAccess){
            navigate('/dashboard');
        }
    }

    
 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const handleNext = () => setStep(step + 1);
    const handleBack = () => setStep(step - 1);
 
    const renderStep = () => {
        switch (step) {
          case 1:
            return <Step1 onNext={handleNext} cid={cid} role={role} token={token} formData={formData} setFormData={setFormData} />;
          case 2:
            return <Step2 onBack={handleBack} onNext={handleNext} token={token} formData={formData} setFormData={setFormData} />;
        //   case 5:
        //     return <Step5 data={formData} onFinish={handleFinish} />;
          default:
            return null;
        }
      };
 
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
                <div className="content-page">
                    {renderStep()}
                </div>
            </div>
        </div>
    )
}
 
export default FeaturesNumber